var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useStaticContext } from '@components/useStaticContext';
import React from 'react';
export var PushableImage = function (_a) {
    var src = _a.src, onImageLoaded = _a.onImageLoaded, restOfProps = __rest(_a, ["src", "onImageLoaded"]);
    var staticContext = useStaticContext();
    var base64Regex = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
    var imagesToPush = staticContext === null || staticContext === void 0 ? void 0 : staticContext.imagesToPush;
    if (imagesToPush instanceof Set && !!src && !base64Regex.test(src)) {
        imagesToPush.add(src);
    }
    return React.createElement("img", __assign({ onLoad: onImageLoaded, src: src }, restOfProps));
};
